import EducationActions from './actions'
import { addNotification as notify } from 'reapop'
import request from './../../utils/requestConfig'
import {paramsWarningNotify} from '../../utils/notifyConfig'

export default class EducationMiddleware {
  static fetchSegments () {
    return (dispatch) => {
      dispatch(EducationActions.fetchSegmentsRequest())
      request.get('/segments?include_grades=true')
        .then(({data}) => {
          dispatch(EducationActions.fetchSegmentsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchSegmentsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar segmentos educacionais!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchSubjects () {
    return (dispatch) => {
      dispatch(EducationActions.fetchSubjectsRequest())
      request.get('/subjects')
        .then(({data}) => {
          dispatch(EducationActions.fetchSubjectsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchSubjectsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar temas!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchAuthors () {
    return (dispatch) => {
      dispatch(EducationActions.fetchAuthorsRequest())
      request.get('/authors')
        .then(({data}) => {
          dispatch(EducationActions.fetchAuthorsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchAuthorsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações dos autores!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchPublishers () {
    return (dispatch) => {
      dispatch(EducationActions.fetchPublishersRequest())
      request.get('/publishers')
        .then(({data}) => {
          dispatch(EducationActions.fetchPublishersSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchPublishersError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações das editoras!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchGrades () {
    return (dispatch, getState) => {
      dispatch(EducationActions.fetchGradesRequest())
      request.get('/grades')
        .then(({ data }) => {
          dispatch(EducationActions.fetchGradesSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchGradesError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações das turmas!',
            status: error.response.status
          }))
        })
    }
  }
  /*
    GET /twentyfirst_competences?name=
    GET /twentyfirst_skills?name=
    GET /oost_subjects?name=
    GET /sels?name=
  */
  static fetchIntelligenceScope () {
    return (dispatch) => {
      dispatch(EducationActions.fetchIntelligenceScopeRequest())
      request.get('/intelligence_scopes')
        .then(({ data }) => {
          dispatch(EducationActions.fetchIntelligenceScopeSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.fetchIntelligenceScopeError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações dos escopos de inteligência!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchOnuGroups () {
    return (dispatch) => {
      dispatch(EducationActions.onuGroupsRequest())
      request.get('/onu_groups')
        .then(({ data }) => {
          dispatch(EducationActions.onuGroupsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.onuGroupsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações dos grupos da Onu!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchOnuGoals (onuGroupsIds = []) {
    return (dispatch, getState) => {
      dispatch(EducationActions.onuGoalsRequest())
      request.get('/onu_goals', {
        params: {
          education_onu_group_ids: onuGroupsIds.toString(),
          per: 100
        }
      })
        .then(({ data }) => {
          dispatch(EducationActions.onuGoalsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.onuGoalsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações dos objetivos da Onu!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchTwentyfirstCompetences () {
    return (dispatch) => {
      dispatch(EducationActions.twentyfirstCompetencesRequest())
      request.get('/twentyfirst_competences')
        .then(({ data }) => {
          dispatch(EducationActions.twentyfirstCompetencesSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.twentyfirstCompetencesError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações das competencias do sec. XXI!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchTwentyfirstSkills () {
    return (dispatch) => {
      dispatch(EducationActions.twentyfirstSkillsRequest())
      request.get('/twentyfirst_skills')
        .then(({ data }) => {
          dispatch(EducationActions.twentyfirstSkillsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.twentyfirstSkillsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações das habilidades do sec. XXI!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchOostSubjects () {
    return (dispatch) => {
      dispatch(EducationActions.oostSubjectsRequest())
      request.get('/oost_subjects')
        .then(({ data }) => {
          dispatch(EducationActions.oostSubjectsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.oostSubjectsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações das disciplinas OOST!',
            status: error.response.status
          }))
        })
    }
  }
  static fetchSels () {
    return (dispatch) => {
      dispatch(EducationActions.selsRequest())
      request.get('/sels')
        .then(({ data }) => {
          dispatch(EducationActions.selsSuccess(data))
        })
        .catch((error) => {
          dispatch(EducationActions.selsError(), '')
          dispatch(notify({
            ...paramsWarningNotify,
            message: 'Não foi possível carregar informações dos selos',
            status: error.response.status
          }))
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/education/middleware.js